import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import IosShareIcon from '@mui/icons-material/IosShare';

const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

const bannerSx = {
  position: 'fixed',
  bottom: 'calc(56px + env(safe-area-inset-bottom, 0px) + 6px)',
  left: 8,
  right: 8,
  bgcolor: 'rgba(14,165,233,0.97)',
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
  color: '#fff',
  px: 2,
  py: 1.5,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  zIndex: 1400,
  borderRadius: 3,
  border: '1px solid rgba(255,255,255,0.18)',
  boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
};

export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('pwa_install_dismissed') === '1'
  );

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (dismissed || isStandalone) return null;
  if (!prompt && !isIos) return null;

  const handleInstall = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setPrompt(null);
  };

  const handleDismiss = () => {
    localStorage.setItem('pwa_install_dismissed', '1');
    setDismissed(true);
  };

  if (isIos) {
    return (
      <Box sx={bannerSx}>
        <IosShareIcon sx={{ flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" fontWeight={700}>Install the app</Typography>
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Tap <IosShareIcon sx={{ fontSize: 12, verticalAlign: 'middle' }} /> then "Add to Home Screen"
          </Typography>
        </Box>
        <IconButton size="small" onClick={handleDismiss} sx={{ color: '#fff', flexShrink: 0 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box sx={bannerSx}>
      <GetAppIcon sx={{ flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" fontWeight={700} noWrap>Install the app</Typography>
        <Typography variant="caption" sx={{ opacity: 0.85 }}>Add to home screen for quick access</Typography>
      </Box>
      <Button
        size="small"
        variant="contained"
        onClick={handleInstall}
        sx={{ bgcolor: '#fff', color: '#0ea5e9', fontWeight: 700, flexShrink: 0, '&:hover': { bgcolor: '#e0f2fe' } }}
      >
        Install
      </Button>
      <IconButton size="small" onClick={handleDismiss} sx={{ color: '#fff', flexShrink: 0 }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
